export default "__VITE_ASSET__ot3EP6uS__"